import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
}), 'CodeTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CodeTwoTone.js
// module id = 2867
// module chunks = 2